<!--
  @Author: DKing
  @Desc: costRateTable,
  @Date: 2019-10-09
-->

<template>
  <div class="cost-rate-table">
    <div class="dk-table-box">
      <div v-if="resDtoListTemp.length < 1">{{ emptyText }}</div>
      <table v-if="resDtoListTemp.length > 0" class="dk-table">
        <thead class="dk-thead">
          <tr>
            <th>商户交易总额/月</th>
            <th v-for="title of headDtoListTemp">
              <div class="th-title-block">
                <div>
                  <span class="th-title-left"
                    >下发费率(单人&lt;{{ title.monthLimitAmount }}/月)</span
                  >
                  <span v-if="restrictFlag">
                    <el-tooltip
                      class="item"
                      v-if="title.restrictFlag === true"
                      effect="dark"
                      content="已开启"
                      placement="top-start"
                    >
                      <span class="dot-green"></span>
                    </el-tooltip>
                    <el-tooltip
                      class="item"
                      v-if="title.restrictFlag === false"
                      effect="dark"
                      content="已关闭"
                      placement="top-start"
                    >
                      <span class="dot-red"></span>
                    </el-tooltip>
                  </span>
                </div>

                <!-- <span class="th-title-right"
                  >先征后返费率(单人&lt;{{ title.monthLimitAmount }}/月)</span
                > -->
              </div>
            </th>
          </tr>
        </thead>

        <tbody class="dk-body">
          <tr v-for="item of resDtoListTemp">
            <td v-if="!item.upperLimitAmountDesc">
              {{ item.upperLimitAmount }}
            </td>
            <td v-else>{{ item.upperLimitAmountDesc }}</td>
            <td v-for="title of item.cooperatorRules" class="td-block">
              <span>{{ title.costRate }}</span>
              <!-- <span>{{ title.discountRate }}</span> -->
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { handleRateRulesListToYuan } from "../filters/filters";

export default {
  name: "cost-rate-table",
  props: {
    resDtoList: Array, // 阶梯费率list
    restrictFlag: {
      type: Boolean,
      default: false
    }
  },
  components: {},

  computed: {},

  data() {
    return {
      resDtoListTemp: this.resDtoList, // 阶梯费率list
      headDtoListTemp: [], // 阶梯费率head
      emptyText: "暂无数据"
    };
  },

  created() {
    this.getDtoList(this.resDtoListTemp);
    console.log("是否开启：", this.restrictFlag);
  },

  mounted() {},

  methods: {
    // 获取阶梯费率
    getDtoList(array) {
      var list = JSON.parse(JSON.stringify(array));
      if (list.length < 1) {
        return;
      }
      list = handleRateRulesListToYuan(list);

      this.resDtoListTemp = list;
      this.headDtoListTemp = list[0].cooperatorRules;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../styles/variable";
.cost-rate-table {
  width: 100%;
  overflow-x: auto;
}

.restrictFlag {
  font-size: 13px;
  color: #847e7e;
}

.th-title-block {
  display: flex;
  div {
    display: flex;
    align-items: center;
    height: 20px;
  }
  .th-title-left {
    width: 190px;
    margin-right: 3px;
    white-space: nowrap;
  }
  .th-title-right {
    margin-left: 10px;
    width: 190px;
    white-space: nowrap;
  }
}

.td-block {
  span {
    width: 190px;
    white-space: nowrap;
    display: inline-block;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/costRateTable.vue